import UserApi from "./user-api";
import SurveyApi from "./survey-api";

const ApiCalls = {
  user: UserApi,
  survey: SurveyApi,
};

export default ApiCalls;
